import { render, staticRenderFns } from "./IndexAnalyzer.vue?vue&type=template&id=6f507fd6&scoped=true&"
import script from "./IndexAnalyzer.vue?vue&type=script&lang=js&"
export * from "./IndexAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f507fd6",
  null
  
)

export default component.exports